import { useEffect, useRef, useState } from "react";
import {
  Typography,
  Stack,
  styled,
  InputBase,
  FormControl,
  InputLabel,
  Button,
  Checkbox,
  Box,
  Divider,
} from "@mui/material";

import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast } from "react-toastify";
import { useCookies } from "react-cookie";

import WithLoginLayout from "../../Layout/withLoginLayout";
import OtherAccountInfo from "./otherAccountInfo";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useCustomNavigate } from "../../Utils/navigationUtils";
import {
  getUserDetails as getUserDetailsAsync,
  addToken,
  logout,
  addClientId,
  startLoading,
  stopLoading,
  addPrincipalName,
  removePrincipalName,
  addChangePassClientId,
  removeChangePassClientId,
  setIsCaptchaChecked,
  addRootToken,
  startCaptchaLoading,
  stopCaptchaLoading,
  addEmailBeforeLogin,
  addUserNameBeforeLogin,
  isCtlUserBeforeLogin,
  addCompanyName,
  removeCompanyName,
  addFirstTimeSetPasswordAccountEnabled,
  setOriginalPrimaryEmail,
  setIsSilentLogin,
  addUserCustomerId,
  logoutClicked,
  setAddUserForRegisterAz,
  addUserName,
  addUserDetails,
  updateLastLoginUserBan,
  updateFlowType,
  flowType
} from "../../SharedContextStore/slices/user";
import {
  getEncryptionQstr,
  getTokenForValidateUserName,
  validateUserName,
  dwLogging,
  getAzureInfo,
} from "../../../../shared/hooks/useFetchLogin";
import { clearNextPaymentDetailSlice } from "../../SharedContextStore/slices/nextPaymentDetails";
import { clearPaymentHistorySlice } from "../../SharedContextStore/slices/paymentHistory";
import { clearPaymentMethodsSlice } from "../../SharedContextStore/slices/paymentMethods";
import { clearServiceDetailSlice } from "../../SharedContextStore/slices/serviceDetails";
import { clearUpcomingAppointmentSlice } from "../../SharedContextStore/slices/upComingAppointment";
import { clearPastAppointmentSlice } from "../../SharedContextStore/slices/pastAppointment";
import { clearPaymentHistoryForPASlice } from "../../SharedContextStore/slices/paymentHistoryForPA";
import {
  clearPlanDetailSlice,
  setChangePlanUrl,
} from "../../SharedContextStore/slices/planDetails";
import { getLoginForgetPageContent } from "../../SharedContextStore/slices/loginForgetPageContent";

import ToastCustonIcon from "../../SharedComponents/toastCustomIcons";
import {
  onPageLoadGTM,
  errorConditionGTM,
  loginGTM,
  forgotUserNameGTM,
  signupGTM,
} from "../../Utils/googleTags";
import AllUrls from "../../../../shared/utils/ApiUrls";
import validateCaptchaToken from "../../../../shared/hooks/useFetchCaptcha";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { getLoginPageContent } from "../../SharedContextStore/slices/contentDetails";
import { onEnterKeyPress, getCaptchaToken, isOnlyForBAU } from "../../Utils/utils";
import LoginRegFooter from "./loginRegFooter";
import { allowedNodeEnvironmentFlags, exit } from "process";
import { sendEventLog } from "../../Utils/app-log";
import {
  EC_DW_LOGGING_STEPS,
  CONST_VALUES,
} from "../../../../shared/utils/Constants";
import fetchAccountInfo from "../../../../shared/hooks/useFetchAccountInfo";
import { clearAddressQualificationState } from "../../SharedContextStore/slices/addressQualification";
import {
  clearNotification,
  notificationSliceSetInitialState,
  setIsMsgReaded,
  setIsReaded,
  setNotificationPanelData
} from "../../SharedContextStore/slices/notificationDetails";
import useBrightspeedHeaders from "../../hooks/useBrightspeedHeader";
import { setHeaders } from "../../SharedContextStore/slices/brightspeedToken";
import DwLogutil, { setCompanyNameWithHeader } from "../../Utils/DwLogutil";
import useLogRegDwlogs from "./logRegDWlogs";
import { setMigrated } from "../../SharedContextStore/slices/migrationCheck";
import { LoginForgetContent } from "../../SharedComponents/contents";
import { setCommunityPreferenceToggle } from "../../SharedContextStore/slices/saveChangesModal";
import { clearProductCategoriesSlice } from "../../SharedContextStore/slices/shopExpProducts";
import { clearAccordionStateSlice } from "../../SharedContextStore/slices/shopaccordion";
import { clearinternetProductsSlice } from "../../SharedContextStore/slices/InternetProductsState";
import { resetAllBanners } from "../../SharedContextStore/slices/notifications";
import { handleModuleFailure } from "../../SharedContextStore/slices/dwLogTracker";



const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },

  "& .MuiInputBase-input": {
    border: "1px solid #7f7f7f",
    position: "relative",
    backgroundColor: "#fff",
    paddingTop: "7px",
    paddingBottom: "9px",
    paddingLeft: "10px",
    height: "24px",
    fontFamily: "Inter",
    fontSize: "16px",
    paddingRight: {
      xs: "30.3px",
      sm: "40.6px",
      md: "47.9px",
      lg: "51.1px",
    },
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ]),
    "&:focus": {
      borderColor: "#000",
      color: "#000000",
    },
  },
}));

const ForgotUserName = () => {
  const isMigrated = useAppSelector((state) => state.isMigrated.isMigrated);
  const emailFeildRef = useRef(null);
  const emailSubmitBtnRef = useRef<HTMLButtonElement>(null);
  const { customNavigate } = useCustomNavigate();
  // const LOGIN_CONTENTS: any = useAppSelector(
  //   (state) => state?.loginForgetPageContent?.loginForgetPageContent
  // );
  const LOGIN_CONTENTS: any = LoginForgetContent();
  const LOGIN_USERNAME = LOGIN_CONTENTS?.entry?.login?.username;
  const loginSchema = yup
    .object({
      email: yup
        .string()
        // .email(LOGIN_USERNAME?.username_error_msg)
        .required(LOGIN_USERNAME?.username_error_msg)
        .nullable(),
    })
    .required();

  const {
    register,
    handleSubmit,
    formState: { isValid, errors, isDirty },
    setError,
    setValue,
    watch,
  } = useForm({
    resolver: yupResolver(loginSchema),
    mode: "onChange",
    defaultValues: {
      email: null,
    },
  });
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const headers = useBrightspeedHeaders();

  const dispatch = useAppDispatch();
  const [cookies, setCookie, removeCookie] = useCookies<any>([
    "loginCridentials",
  ]);
  const globalToken = useAppSelector((state) => state?.brightspeedToken?.data);
  // const sessionId = useAppSelector((state) => state?.user?.sessionId);
  const [rootToken, setRootToken] = useState("");
  const [captchaScore, setCaptchaScore] = useState<any>("");
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const [rememberMeBtnChecked, setRememberMeBtnChecked] = useState(false);
  const user = useAppSelector((state) => state?.user);
  const { refreshToken } = useAppSelector((state) => state?.user);
  const location: any = useLocation();
  const {logRegDwLogs: logRegDwlogs, checkFlowAndFinishFlow} = useLogRegDwlogs();
  

  useEffect(() => {
    if (!LOGIN_CONTENTS) {
      getContent();
    }
    sessionStorage.removeItem("appDownloadModalHide");
    localStorage.removeItem("alreadyShownPaymentMethodMsg");
    localStorage.removeItem("loginUserAddressId");
    localStorage.removeItem("loginUserBan");
    dispatch(logout());
    dispatch(resetAllBanners());
    dispatch(logoutClicked(false));
    localStorage.removeItem("headersSiteId");
    dispatch(updateFlowType(flowType?.login));
    dispatch(clearNextPaymentDetailSlice());
    dispatch(clearPaymentHistorySlice());
    dispatch(clearPaymentHistoryForPASlice());
    dispatch(clearPaymentMethodsSlice());
    dispatch(clearServiceDetailSlice());
    dispatch(clearProductCategoriesSlice());
    dispatch(clearAccordionStateSlice());
    dispatch(clearinternetProductsSlice());
    dispatch(clearUpcomingAppointmentSlice());
    dispatch(clearPastAppointmentSlice());
    dispatch(clearPlanDetailSlice());
    dispatch(setChangePlanUrl(""));
    dispatch(setAddUserForRegisterAz(null));
    //delete headers["refresh-token"];
    dispatch(setHeaders({ ...headers, siteId: "" }));
    dispatch(clearAddressQualificationState());
    dispatch(addUserDetails(null));
    dispatch(addUserCustomerId(""));
    dispatch(notificationSliceSetInitialState());
    dispatch(setNotificationPanelData([]));
    dispatch(setCommunityPreferenceToggle(false));
    onPageLoadGTM(
      "login",
      undefined,
      user?.sessionId,
      user?.data?.billingAccountNumber,
      user?.companyName
    );
    if (!refreshToken && headers?.["refresh-token"]) {
      const tempHeader = {...headers}
      delete tempHeader['refresh-token'];
      dispatch(
        setHeaders({
          ...tempHeader
        })
      );
    }
  }, []);

  useEffect(() => {
    if (
      process.env.REACT_APP_ENV === "production" &&
      globalToken?.access_token &&
      headers?.Authorization &&
      captchaScore >= 0
    ) {
      getCaptchaTokenAsync();
    } else if (
      process.env.REACT_APP_ENV !== "production" &&
      captchaScore >= 0
    ) {
      getCaptchaTokenAsync();
    }
  }, [globalToken, headers]);

  useEffect(() => {
    if (cookies?.brspdam_userid) {
      setRememberMeBtnChecked(true);
      setValue("email", cookies?.brspdam_userid);
    }
  }, []);

  const getContent = async () => {
    await dispatch(getLoginForgetPageContent());
  };

  const getCaptchaTokenAsync = async () => {
    try {
      dispatch(startCaptchaLoading());
      const token = await getCaptchaToken();
      if (token) {
        const captchaValidateTokenRes = await validateCaptchaToken(
          {
            "": `${AllUrls?.captchaTokenValidateURL}?token=${token}&flow=login`,
          },
          headers
        );
        dispatch(setIsCaptchaChecked());
        if (captchaValidateTokenRes?.data?.riskAnalysis?.score >= 0) {
          logRegDwlogs({
            fromAPI: true,
            API_StepName: "RECAPTCHA_API",
            email: "",
          })
          const { score } = captchaValidateTokenRes?.data?.riskAnalysis;
          setCaptchaScore(score);
          //FS log
          sendEventLog("Recaptcha Success", {
            recpatcha_score_real: score,
          });
        } else {
          logRegDwlogs({
            fromAPI: true,
            API_StepName: "RECAPTCHA_API",
            email: "",
            error: "Something went wrong for re-captcha API"
          })
         // dispatch(handleModuleFailure("login", "Something went wrong for re-captcha API","loginFlow"))
          setCaptchaScore(1);
        }
        dispatch(stopCaptchaLoading());
      } else {
        dispatch(stopCaptchaLoading());
        dispatch(setIsCaptchaChecked());
        setCaptchaScore(1);
      }
    } catch (error) {
      logRegDwlogs({
        fromAPI: true,
        API_StepName: "RECAPTCHA_API",
        email: "",
        error: "Something went wrong for re-captcha API"
      })
      //  dispatch(handleModuleFailure("login", "Something went wrong for re-captcha API","loginFlow"))

      dispatch(stopCaptchaLoading());
      dispatch(setIsCaptchaChecked());
      setCaptchaScore(1);
      console.error(error);
    }
  };

  const isEmail = (value: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
  };

  const onSubmit = async (data: any) => {
    if (data?.email) {
      sessionStorage.setItem("displayDownTimeModal","true")
      const isEmail = /\S+@\S+\.\S+/.test(data?.email);
      localStorage.setItem("isEmail",`${isEmail}`)
      logRegDwlogs({
        fromAPI: false,
        email: data?.email,
        stepName: "login",
        stepNameType: "attempts"
      });
      localStorage.removeItem(`isAccountLocked_${data?.email}`);
      if (rememberMeBtnChecked) {
        setCookie("brspdam_userid", data?.email, { path: "/" });
      } else {
        removeCookie("brspdam_userid", { path: "/" });
      }
      // await dispatch(getUserDetailsAsync(data?.email));
      // dispatch(addToken(data?.email));
      // localStorage?.setItem("token", data?.email);
      try {
        dispatch(startLoading());
        const validateUserNameRes = await getAzureInfo(
          {
            "": `${AllUrls?.getAzureInfoUrl}?email=${encodeURIComponent(
              data?.email?.trim()
            )}`,
          },
          headers
        );
        loginGTM(
          "digital_login-pswd_acct_mgmt",
          data?.email,
          validateUserNameRes?.data?.value[0]?.companyName || ""
        );
        if(validateUserNameRes?.data?.value?.[0]?.identities?.[0]?.issuerAssignedId?.trim()) {
          validateUserNameRes.data.value[0].identities[0].issuerAssignedId = decodeURIComponent(validateUserNameRes?.data?.value[0]?.identities[0]?.issuerAssignedId?.trim())
        }
        setCompanyNameWithHeader(validateUserNameRes?.data?.value[0]?.companyName || "", headers);
        // add companyName in redux
        dispatch(
          addCompanyName(validateUserNameRes?.data?.value[0]?.companyName || "")
        );
        dispatch(
          addUserName(validateUserNameRes?.data?.value[0]?.identities?.length > 0 && validateUserNameRes?.data?.value[0]?.identities[0]?.issuerAssignedId || "")
        );
        localStorage.setItem("emailID", data?.email);
        if (
          validateUserNameRes?.status === 200 &&
          validateUserNameRes?.data?.value?.length && data?.email?.trim()?.toUpperCase() === validateUserNameRes?.data?.value[0]?.identities[0]?.issuerAssignedId?.trim()?.toUpperCase()
        ) {
          dispatch(stopLoading());
          dispatch(addClientId(validateUserNameRes?.data?.clientId));
          logRegDwlogs({
            fromAPI: true,
            email: data?.email,
            API_StepName: "AZINFO_API",
          });
            validateUserNameRes?.data?.value[0]?.accountEnabled
              ? 
              dwLogging(
                {
                  "": AllUrls?.dwLoggingUrl,
                },
                {
                  sessionId:
                    user?.sessionId || localStorage?.getItem("sessionId") || "",
                  stepName: EC_DW_LOGGING_STEPS.account_enabled,
                  cta: "Success",
                  userEmail: data?.email,
                  customerType:
                    validateUserNameRes?.data?.value[0]?.companyName || "",
                },
                headers
              ): dispatch(handleModuleFailure("login", EC_DW_LOGGING_STEPS.account_not_enabled,"loginFlow"))

          dispatch(stopLoading());

          if(!validateUserNameRes?.data?.value[0]?.[CONST_VALUES?.customer_id_key]) {
            // DwLogutil({
            //   stepName: EC_DW_LOGGING_STEPS.cust_ID_Not_Found,
            //   error: "CustmerId not found"
            // })
            dispatch(handleModuleFailure("login", "CustmerId not found","loginFlow"))
          }

          if (
            ["CENTURY LINK", "CTL"]?.includes(validateUserNameRes?.data?.value[0]?.companyName
              ?.trim()
              ?.toUpperCase()) &&
            !validateUserNameRes?.data?.value[0]?.accountEnabled
          ) {
            // set the flag for migrated CTL user first time login
            localStorage.setItem("MI-CTL-FT-LOGIN", data?.email);
            localStorage.setItem("MI-CTL-FT-WELCOME-MSG", data?.email);
          }

          dispatch(
            addFirstTimeSetPasswordAccountEnabled(
              validateUserNameRes?.data?.value[0]?.accountEnabled
            )
          );

          if (
            validateUserNameRes.data.value[0]
              ?.extension_42054e1351c040b08b185b58c192f49e_domain
          ) {
            dispatch(setOriginalPrimaryEmail(data?.email));
          }

          const accountEnabledkMsg =
            validateUserNameRes?.data?.value[0]?.[
              CONST_VALUES?.account_enabled_message_key
            ];

          // this below if condition is for silent login feature
          if (
            !!!validateUserNameRes?.data?.value[0]?.accountEnabled ||
            (accountEnabledkMsg &&
              accountEnabledkMsg === CONST_VALUES?.account_lock)
          ) {
            if (accountEnabledkMsg === CONST_VALUES?.account_lock) {
              dispatch(updateFlowType(flowType.account_lock));
              logRegDwlogs({
                fromAPI: false,
                email: data?.email,
                stepName: "account_lock",
                stepNameType: "attempts",
                flowType: "account_lock"
              });
              localStorage.setItem(`isAccountLocked_${data?.email}`, "true");
            } else {
              logRegDwlogs({
                fromAPI: false,
                email: data?.email,
                stepName: "silent_login",
                stepNameType: "attempts",
                flowType: "silent_login"
              });
              dispatch(updateFlowType(flowType.silent_login));
            }
            dispatch(
              addEmailBeforeLogin(
                validateUserNameRes.data.value[0]
                  ?.extension_42054e1351c040b08b185b58c192f49e_domain ||
                  data?.email
              )
            );
            dispatch(setIsSilentLogin(true));
            dispatch(
              addEmailBeforeLogin(
                validateUserNameRes.data.value[0]
                  ?.extension_42054e1351c040b08b185b58c192f49e_domain ||
                  data?.email
              )
            );
            dispatch(setIsSilentLogin(true));
            dispatch(
              addPrincipalName(
                validateUserNameRes?.data?.value[0]?.userPrincipalName
              )
            );
            dispatch(
              addUserCustomerId(
                validateUserNameRes?.data?.value[0]?.[
                  CONST_VALUES?.customer_id_key
                ] || ""
              )
            );
            
            customNavigate(`/set-password-validate`);
            return;
          }
          dispatch(
            addPrincipalName(
              validateUserNameRes?.data?.value[0]?.userPrincipalName
            )
          );
          // add companyName in redux
          dispatch(
            addCompanyName(
              validateUserNameRes?.data?.value[0]?.companyName || ""
            )
          );
          dispatch(
            addUserName(validateUserNameRes?.data?.value[0]?.identities?.length > 0 && validateUserNameRes?.data?.value[0]?.identities[0]?.issuerAssignedId || "")
          );

          dispatch(
            addUserCustomerId(
              validateUserNameRes?.data?.value[0]?.[
                CONST_VALUES?.customer_id_key
              ] || ""
            )
          );
          dwLogging(
            {
              "": AllUrls?.dwLoggingUrl,
            },
            {
              sessionId:
                user?.sessionId || localStorage?.getItem("sessionId") || "",
              stepName: EC_DW_LOGGING_STEPS.login_attempts,
              cta: "Success",
              userEmail:
                validateUserNameRes.data.value[0]
                  ?.extension_42054e1351c040b08b185b58c192f49e_domain ||
                data?.email,
              customerType:
                validateUserNameRes?.data?.value[0]?.companyName || "",
            },
            headers
          );

          if (
            window.location.href === "https://myaccount.brightspeed.com/"
              ? captchaScore < 0.5
              : captchaScore < 0
          ) {
            dispatch(updateFlowType(flowType?.login_with_recaptcha));
            logRegDwlogs({
              fromAPI: false,
              email: data?.email,
              stepName: "login_with_recaptcha",
              stepNameType: "attempts",
              flowType: "login_with_recaptcha"
            });
            dispatch(
              addEmailBeforeLogin(
                validateUserNameRes.data.value[0]
                  ?.extension_42054e1351c040b08b185b58c192f49e_domain ||
                  data?.email
              )
            );
            DwLogutil({ email: data?.email, stepName: EC_DW_LOGGING_STEPS?.validateUserDueToReCaptcha });
            customNavigate(`/validate-login`);
          } else {
            dispatch(
              addEmailBeforeLogin(
                validateUserNameRes.data.value[0]
                  ?.extension_42054e1351c040b08b185b58c192f49e_domain ||
                  data?.email
              )
            );
            dispatch(updateLastLoginUserBan(validateUserNameRes?.data?.value[0]?.[CONST_VALUES?.lastLoginBanKey]
            ));
            dispatch(updateFlowType(flowType?.login));
            customNavigate(`/login-password`);
          }
        } else {
          dispatch(stopLoading());
          setError("email", {
            type: "custom",
            message: LOGIN_USERNAME?.username_error_msg});
          dispatch(removePrincipalName());
          dispatch(removeCompanyName());
          setShowErrorMsg(true);
          //FS log
          sendEventLog("AM Log in Failure", {
            am_login_failure_reason_string: "Username not found",
          });
          // logRegDwlogs({
          //   fromAPI: true,
          //   email: data?.email,
          //   API_StepName: "AZINFO_API",
          //   error: "Username/principalName not found"
          // });
          // dwLogging(
          //   {
          //     "": AllUrls?.dwLoggingUrl,
          //   },
          //   {
          //     sessionId:
          //       user?.sessionId || localStorage?.getItem("sessionId") || "",
          //     stepName: EC_DW_LOGGING_STEPS.username_notfound,
          //     cta: "Failed",
          //     userEmail: data?.email,
          //     error: "Username/principalName not found",
          //   },
          //   headers
          // );
          dispatch(handleModuleFailure("login", "Username/principalName not found","loginFlow"))
        }
      } catch (error) {
        errorConditionGTM(
          "BRSPD_Fiber_EC_Flow",
          "IAM get user by username",
          error,
          undefined,
          user?.sessionId,
          user?.data?.billingAccountNumber,
          user?.companyName
        );
        dispatch(stopLoading());
        setError("email", {
          type: "custom",
          message: LOGIN_USERNAME?.username_error_msg});
        dispatch(removePrincipalName());
        dispatch(removeCompanyName());
        setShowErrorMsg(true);
        console.error(error);
        // logRegDwlogs({
        //   fromAPI: true,
        //   email: data?.email,
        //   API_StepName: "AZINFO_API",
        //   error: "Username/principalName not found"
        // });
        // dwLogging(
        //   {
        //     "": AllUrls?.dwLoggingUrl,
        //   },
        //   {
        //     sessionId:
        //       user?.sessionId || localStorage?.getItem("sessionId") || "",
        //     stepName: EC_DW_LOGGING_STEPS.username_notfound,
        //     cta: "Failed",
        //     userEmail: data?.email,
        //     error: "Username not found",
        //   },
        //   headers
        // );
        dispatch(handleModuleFailure("login", "Username not found","loginFlow"))
      }
    }
  };

  // const onError = async (data: any) => {
  //   if (watch("email")) {
  //     const encriptedEmail = await getEncriptedEmailId(watch("email") || "");
  //     if (
  //       process.env.REACT_APP_CENTURY_LINK_EMAIL_PRE_POPULATE &&
  //       watch("email") &&
  //       encriptedEmail
  //     ) {
  //       return window?.open(
  //         `${process.env.REACT_APP_CENTURY_LINK_EMAIL_PRE_POPULATE}?userId=${encriptedEmail}`,
  //         "_self"
  //       );
  //     }
  //   }
  // };

  const getEncriptedEmailId = async (emailId: string) => {
    try {
      dispatch(startLoading());
      const encriptData = await getEncryptionQstr(
        {
          "": AllUrls?.encryptionQstr_Url,
        },
        {
          email: emailId,
        },
        headers
      );
      dispatch(stopLoading());
      if (encriptData?.status === 200 && encriptData?.data) {
        return encriptData?.data;
      }
      return false;
    } catch (error) {
      dispatch(stopLoading());
      return false;
    }
  };

  const dwLogs = async () => {
    dwLogging(
      {
        "": AllUrls?.dwLoggingUrl,
      },
      {
        sessionId: user?.sessionId || localStorage?.getItem("sessionId") || "",
        stepName: EC_DW_LOGGING_STEPS.forgot_username_attempt,
        cta: "Success",
        userEmail: "",
      },
      headers
    );
  };

  const createUserDwLogs = async () => {
    dwLogging(
      {
        "": AllUrls?.dwLoggingUrl,
      },
      {
        sessionId: user?.sessionId || localStorage?.getItem("sessionId") || "",
        stepName: EC_DW_LOGGING_STEPS.Create_account_CTA,
        cta: "Success",
        userEmail: "",
      },
      headers
    );
  };
  useEffect(() => {
    if(!isMigrated){
      const migrationCheck = searchParams.get('migratedCTL') === "Y";
      dispatch(setMigrated(migrationCheck));
    }
  }, []);

  return (
    <WithLoginLayout>
      <Stack className="loginMain">
        
        <Typography component="h1" className="title">
          {searchParams?.has("non-payment")
            ? LOGIN_USERNAME?.non_payment_title
            : LOGIN_USERNAME?.title}
            </Typography>
        <Typography>
        <Typography className="desc">
          {location?.state?.QF_user
            ? "You can manage your service, change your plan and update your payment options, all in one place. Enter your username below to get going."
            : (location?.state?.Migrated_Ctl || searchParams.get("migratedCTL") === "Y" || localStorage?.getItem("redirectPath")?.includes("migratedCTL=Y"))
            ? "You can now access and manage your saved payment methods more easily. Plus, more features that give you complete control over your account."
            : LOGIN_USERNAME?.description}
        </Typography>
        {location?.state?.Migrated_Ctl ? (
          <Typography className="desc">
            Enter your username and follow the steps to get going.
          </Typography>
        ) : null}
        </Typography>
        
        <FormControl variant="standard" className="form">
          <InputLabel shrink htmlFor="email" className="email">
            {LOGIN_USERNAME?.username_label}*
          </InputLabel>
          <BootstrapInput
            autoFocus
            inputRef={emailFeildRef}
            aria-describedby="username-error" 
              inputProps={{
                "aria-invalid":
                  errors && Object.keys(errors)?.includes("email") ? "true" : "false",
                "aria-required": true,
              }}
            type="email"
            defaultValue=""
            id="email"
            {...register("email")}
            placeholder={LOGIN_USERNAME?.username_placeholder}
            className={
              Object.keys(errors).length !== 0 && showErrorMsg
                ? "showErrorBorder fs-mask"
                : "fs-mask"
            }
            onKeyPress={(e) => {
              onEnterKeyPress(e, (event: any) => {
                handleSubmit(onSubmit)(event);
              });
            }}
            onBlur={(e) => {
              Object.keys(errors).length !== 0
                ? setShowErrorMsg(true)
                : setShowErrorMsg(false);
            }}
          />

          {showErrorMsg && (
            <ErrorMessage
              errors={errors}
              name="email"
              render={({ message }) => (
                <>
                  <Box className="errorMsgFormat" id="username-error">
                    <span className="inputFiledErrorImg"></span>
                    <span className="inputFiledErrorMsg">{message}</span>
                  </Box>
                </>
              )}
            />
          )}
        </FormControl>
        <Box className="rememberMe">
          <Typography component="span" className="checkBox">
            <label className="checkboxMain" htmlFor="rememberme">
              {LOGIN_USERNAME?.remember_label}
              <input aria-describedby="chkremember" id="rememberme"
                type="checkbox"
                className="radioInput"
                checked={rememberMeBtnChecked}
                aria-checked={rememberMeBtnChecked}
                onChange={(e: any) =>
                  setRememberMeBtnChecked(e?.target?.checked)
                }
              />
              <span className="checkBoxLabel"></span>
            </label>
            {
              // <Checkbox /> {LOGIN_USERNAME?.remember_label}
            }
          </Typography>
          <div id="chkremember" className="hiddenReader">{ LOGIN_USERNAME?.username_label +  LOGIN_USERNAME?.remember_label}</div>
          <Typography
            className="forgotUsername buttonLinks ul p-0 font-secondary"
            component="button"
            role="link"
            onClick={() => {
              forgotUserNameGTM();
              dwLogs();
              dispatch(updateFlowType(flowType?.forget_username));
              customNavigate(process.env.REACT_APP_ENABLE_FIND_USERNAME?"/find-username":"/new-forget-username");
            }}
          >
            {LOGIN_USERNAME?.forgot_user_label}

          </Typography>
        </Box>
        <Box className="required-lable">
          <span>*{LOGIN_USERNAME?.required}</span>
        </Box>
        <Button
          disabled={isDirty && showErrorMsg ? !isValid : !watch("email")}
          // disabled={!watch("email")}
          className="homeButton btnEnabled"
          onClick={handleSubmit(onSubmit)}
          ref={emailSubmitBtnRef}
        >
          {LOGIN_USERNAME?.continue_button_label} 
        </Button>

        <Box component="span" className="createAccount">
          {LOGIN_USERNAME?.firsttime_signin_label}{" "}
          <Typography
            component="button" role="link"
            onClick={() => {
              signupGTM();
              createUserDwLogs();
              dispatch(updateFlowType(flowType?.silent_registration));
              customNavigate("/signUp");
            }}
            className="signup buttonLinks p-0"
          >
            {LOGIN_USERNAME?.create_account_link}
          </Typography>
        </Box>
        <Divider className="logindivider" role="presentation"/>
        <LoginRegFooter />
      </Stack>
    </WithLoginLayout>
  );
};
export default ForgotUserName;
